module.exports = __webpack_public_path__ + "static/media/home.d995a60f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home.svg
// module id = 2091
// module chunks = 33